module.exports = __webpack_public_path__ + "static/media/Bannerinactive.6a761ed8.svg";